import React from "react";

const CustomerComp = () => {
  return (
    <div className="sales-tool-root">
      <h1>CustomerComp comp</h1>
    </div>
  );
};

export default CustomerComp;